export default __webpack_public_path__ + "static/media/Lobby For Splash Page.fe7b5ab9.png";